import ManageDepartment from 'src/sections/view_department/ManageDepartment';
import ViewDepartmentContextProvider from 'src/sections/view_department/ViewDepartmentContext';

const ViewDepartments = () => (
  <ViewDepartmentContextProvider>
    <ManageDepartment />
  </ViewDepartmentContextProvider>
);

export default ViewDepartments;
